import axios from "axios";

const axiosRequest = {
  state: {},
  mutations: {
    requestStatus(state, { status }) {
      console.log("status : ", status);
    },
  },
  actions: {
    // async postSend({commit},{paths, params}){
    async postSend(commit, { paths, params }) {
      console.log("post 요청 영역 진입");
      console.log(paths);
      console.log(params);
      const result = await axios.post(paths, params, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log(result.data);
      if (result.status == 200) {
        if (result.data["code"] == 0) {
          return result.data;
        } else if (result.data["code"] == 30001) {
          return result.data;
        } else {
          return result.data;
        }
        // commit('requestStatus', result.data['code'])

        // result.data 리턴 받기 위해 기존 내용 주석처리하고
        // else 구문 추가하였음 (선경)
      }
    },
    async paymentRequest(commit, { paths, params }) {
      console.log("post 요청 영역 진입");
      console.log(paths);
      console.log(params);
      const result = await axios.post(paths, params, {
        headers: {
          // 'Accept' : 'text/html,application/xhtml+xml,*/*',
          // 'Host' : 'api.payapp.kr',
          'Accept-Language' : 'ko-KR',
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin" : "*"
        },
      });
      console.log(result);

    },
  },
};

export default axiosRequest;
